import React, { useState } from 'react';
import axios from 'axios';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [status, setStatus] = useState('');

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!name || !imageFile) {
      setStatus('Name and image are required.');
      return;
    }

    setStatus('Uploading...');

    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('phone', phone);
      formData.append('image', imageFile); // send file

      const resp = await axios.post('https://attendance-api.elitewebpro.com/api/employees/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (resp.data.success) {
        setStatus('Employee added! ID: ' + resp.data.id);
        setName('');
        setEmail('');
        setPhone('');
        setImageFile(null);
      } else {
        setStatus('Error adding employee.');
      }
    } catch (err) {
      console.error(err);
      setStatus('Server error.');
    }
  };

  return (
    <div>
      <h3>Register Employee</h3>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <input
        type="text"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <input
        type="text"
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        style={{ display: 'block', marginBottom: 10 }}
      />
      <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'block', marginBottom: 10 }} />
      <button onClick={handleSubmit}>Add Employee</button>
      <div style={{ marginTop: 10 }}>{status}</div>
    </div>
  );
}
